// extracted by mini-css-extract-plugin
module.exports = {"saytItemText":"SaytItemText_saytItemText__yJH3R","saytMisoAutoSuggest":"SaytItemText_saytMisoAutoSuggest__38TZJ"};